<template>
  <div>
    <b-form>
      <b-form-row>
        <b-col cols="3">
          <b-form-group label="Academic Year">
            <b-form-select v-model="filter.academicYear" :options="ayOptions" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group class="pt-4">
            <b-btn variant="primary" class="m-1" @click="showFilters = !showFilters">
              <i class="fa fa-filter fa-fw" /> {{ showFilters ? 'Hide' : 'Show' }} Filters
            </b-btn>
            <b-btn variant="primary" class="m-1" @click="applyFilter" v-if="!showFilters">
              Load Data
            </b-btn>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>

<script>
import FilterItem from './FilterItem.vue'
import { gradeSpans } from '@/helpers/gradeSpans'
import { mapState } from 'vuex'
import { metadata as staticMetadata } from '@/modules/cte/stores/careercoach/metadata'
const sessionStorageTag = 'careerCoachReportsFilterDuplicateContacts'

export default {
  components: { FilterItem },
  data() {
    return {
      topic: null,
      academicYear: null,
      showFilters: false,
      staticMetadata,
      filter: {
      }
    }
  },
  computed: {
    ...mapState('cte/careercoach/reporting', ['rosterDates']),
    careerCoachGrades() {
      var grades = gradeSpans.filter(g=>g.value >= 7 && g.value <= 12);
      return grades
    },
  }, 
  props: {
    ayOptions: Array
  },
  methods: {
    applyFilter() {
      // Save filter to sessionStorage
      try {
        sessionStorage.setItem(sessionStorageTag, JSON.stringify({...this.filter, academicYear: this.filter.academicYear}));
      } catch (e) {
        // Optionally log error
      }
      this.$emit('apply-filter', this.filter)
    }
  },
  mounted() {
    // Load filter from sessionStorage if available
    try {
      const savedFilter = sessionStorage.getItem(sessionStorageTag);
      if (savedFilter) {
        this.filter = JSON.parse(savedFilter);
        if (this.filter.academicYear) {
          this.filter.academicYear = parseInt(this.filter.academicYear, 10);
        } else {
          this.filter.academicYear = this.ay;
        }
        this.$emit('apply-filter', this.filter)
      }
    } catch (e) {
      this.filter.academicYear = this.ay;
    }
  }
}
</script>